__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "mfe-ui-header";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@auth0/auth0-react", "2.2.3", () => (Promise.all([__webpack_require__.e(211), __webpack_require__.e(4187)]).then(() => (() => (__webpack_require__(211))))));
			register("@azure/msal-browser", "3.6.0", () => (Promise.all([__webpack_require__.e(3798), __webpack_require__.e(9785)]).then(() => (() => (__webpack_require__(3798))))));
			register("@azure/msal-react", "2.0.5", () => (Promise.all([__webpack_require__.e(1313), __webpack_require__.e(3015), __webpack_require__.e(3373), __webpack_require__.e(319)]).then(() => (() => (__webpack_require__(1313))))));
			register("@ey-xd/motif-react", "6.8.0", () => (Promise.all([__webpack_require__.e(5076), __webpack_require__.e(2198), __webpack_require__.e(4914), __webpack_require__.e(3015), __webpack_require__.e(192), __webpack_require__.e(9080), __webpack_require__.e(6997)]).then(() => (() => (__webpack_require__(2198))))));
			register("@ey/mfe-ui-core", "1.48.0", () => (Promise.all([__webpack_require__.e(9037), __webpack_require__.e(4914), __webpack_require__.e(5302), __webpack_require__.e(2700)]).then(() => (() => (__webpack_require__(9037))))));
			register("@splitsoftware/splitio-react", "1.11.1", () => (Promise.all([__webpack_require__.e(9515), __webpack_require__.e(192)]).then(() => (() => (__webpack_require__(9515))))));
			register("@tanstack/react-query", "5.69.0", () => (Promise.all([__webpack_require__.e(3719), __webpack_require__.e(5931), __webpack_require__.e(4150), __webpack_require__.e(4629)]).then(() => (() => (__webpack_require__(3719))))));
			register("axios", "1.8.2", () => (Promise.all([__webpack_require__.e(8291), __webpack_require__.e(5557)]).then(() => (() => (__webpack_require__(8291))))));
			register("react-dom", "18.3.1", () => (Promise.all([__webpack_require__.e(6074), __webpack_require__.e(318)]).then(() => (() => (__webpack_require__(6074))))));
			register("react-router-dom", "6.23.1", () => (Promise.all([__webpack_require__.e(4246), __webpack_require__.e(2061)]).then(() => (() => (__webpack_require__(4246))))));
			register("react", "18.3.1", () => (__webpack_require__.e(6911).then(() => (() => (__webpack_require__(6911))))));
			register("redux-micro-frontend", "1.3.0", () => (Promise.all([__webpack_require__.e(8258), __webpack_require__.e(7938)]).then(() => (() => (__webpack_require__(8258))))));
			initExternal(2345);
			initExternal(9626);
			initExternal(9415);
			initExternal(1316);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};